<div
  class="policyWidget paymentWidgetMMDirect paymentWidget paymentFormWidget mmDirectWidget"
  *ngIf="updatePaymentPayload"
>
  <div class="wrap wrapClose">
    <div class="wrapClose__content header">
      <div class="header__content">
        <div class="header__logo-image wrapClose__logo" alt="MassMutual"></div>
        <button type="button" class="close" (click)="checkCancel();">Close</button>
      </div>
    </div>
  </div>

  <div class="wrap wrapHead">
    <div class="pageHead">
      <h1 class="payment-form__heading" *ngIf="policyAdminDown">
        Please contact SupportDirectTerm@massmutual.com for assistance.
      </h1>
      <h1 class="payment-form__heading" *ngIf="!policyAdminDown">Update bank account</h1>
      <div class="subhead" *ngIf="!policyAdminDown">
        <payment-form-subhead
          [formType]="'mmdirect'"
          [receivedPaymentInfo]="receivedPaymentInfo"
        ></payment-form-subhead>
      </div>
      <div *ngIf="!policyAdminDown" class="center">
        <img src="/common/widgets/icons/divider.svg" />
      </div>
    </div>
  </div>

  <div class="wrap wrapMain" *ngIf="!policyAdminDown">
    <bank-account-form-mmdirect
      #BankAccountForm
      [receivedPaymentInfo]="receivedPaymentInfo"
      [updatePaymentPayload]="updatePaymentPayload"
      (updateComplete)="handleFinish($event)"
    >
      <div class="legalText">
        <auth-statement
          [formType]="'mmdirect'"
          [receivedPaymentInfo]="receivedPaymentInfo"
          [updatePaymentPayload]="updatePaymentPayload"
        ></auth-statement>
      </div>
      <div class="terms">
        <a class="standard-link" href="/common/pdf/{{termsPDF}}" target="_blank">
          Premium Payment Service Terms &amp; Conditions
        </a>
      </div>
    </bank-account-form-mmdirect>
  </div>
</div>

<modal *ngIf="receivedPaymentInfo && !policyAdminDown && modalService.showModal" [dismiss]="dismiss"></modal>
